import { getIntegrationKey } from './getIntegrationKey';
import { getBackendFlowKey } from './getBackendFlowKey';
export const getBackendIntegrationOrFlowKey = () => {
  return getIntegrationKey() || getBackendFlowKey();
};